/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import { Col, FloatButton, Image, Input, Modal, Row, Typography } from "antd";
import { MetaTags } from "react-meta-tags";
import {
  CommentOutlined,
  CloseOutlined,
  BankFilled,
  // FacebookOutlined,
  // GoogleCircleFilled,
  // PinterestOutlined,
  InstagramOutlined,
  // LinkedinOutlined,
  // YoutubeOutlined,
  XOutlined,
} from "@ant-design/icons";
// import ContactUsLogo from "../../../assets/images/customer-support-2.jpg";
import { FaPhoneVolume } from "react-icons/fa6";
import Comment from "../../../assets/images/comment.jpg";
import Question from "../../../assets/images/question-mark.jpg";
import contactUsLogo from "../../../assets/images/contact-us-banner-2.jpg";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { IoLogoYoutube } from "react-icons/io5";
import "react-range-slider-input/dist/style.css";
import { FaFacebook, FaLinkedin } from "react-icons/fa";
// import { isEmpty } from "lodash";

const ContactUs = (props) => {
  const media = useMedia();
  // const packageDetailsData =
  //   props && props.location && props.location.state ? props.location.state : "";

  //Initial state

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  console.log(windowDimensions, "windowDimensions");

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const position = [76.97054647513443, 11.016925791460556];
  const mapSrc = `https://maps.google.com/maps?q=${position[1]},${position[0]}&z=15&output=embed`;
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Contact us | Plan mi trip</title>
        </MetaTags>
      </div>
      <Row>
        <Col
          md={24}
          sm={24}
          xs={24}
          lg={24}
          xl={24}
          xxl={24}
          className={
            windowDimensions.width > 900 && windowDimensions.width < 991
              ? "mt-[-20px]"
              : windowDimensions.width > 991 && windowDimensions.width < 1025
              ? "mt-[44px]"
              : "mt-[-20px] sm:mt-[-10px] lg:mt-[42px] xl:mt-[-20px]"
          }
        >
          <Image
            src={contactUsLogo}
            preview={false}
            width={"101%"}
            className="ml-[-3px]"
            height={280}
          />
        </Col>
      </Row>
      <Row
        className={
          media == "sm"
            ? "pr-[6%] pl-[6%] w-[100%] mt-4"
            : media == "xs"
            ? "pr-[40px] pl-[40px] w-[100%] mt-4"
            : media == "md"
            ? "pr-[12%] pl-[12%] w-[100%] mt-4"
            : media == "lg"
            ? "pr-[15%] pl-[15%] w-[100%] mt-[80px]"
            : media == "xxl"
            ? "pr-[10%] pl-[10%] w-[100%] mt-4"
            : "pr-[8%] pl-[10%] w-[100%] mt-4"
          // media === "md"
          //   ? "mt-10 pl-[140px] pr-[120px] w-[100%]"
          //   : media == "sm" || media == "xs"
          //   ? "pl-[40px] pr-[30px] w-[100%]"
          //   : "pl-[140px] pr-[120px] w-[100%]"
        }
        style={{
          position: "relative",
        }}
      >
        <Col
          md={24}
          sm={24}
          xs={24}
          lg={16}
          xl={16}
          xxl={16}
          className="mb-[-50px]"
        >
          <Row>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mb-2"
            >
              <div className="w-[100%]">
                <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="text-[24px] font-extrabold mb-1"
                >
                  Contact our team
                </h1>
                <p
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="text-[13px] mb-1"
                >
                  Got any questions about travelling or scaling on our website?
                  we are help.
                </p>
                <p
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="text-[13px] mb-1"
                >
                  Chat to our friendly team 24/7 and get onboard in less than 5
                  minutes
                </p>
              </div>
            </Col>

            <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
              <Row className="mt-3">
                <Col md={24} sm={24} xs={24} lg={12} xl={12} xxl={12}>
                  <Row>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="bg-[#ebebeb] pl-4 pr-4 pt-3 pb-2 rounded-md mb-3"
                    >
                      <div className="w-[100%] flex">
                        <FaPhoneVolume size="20px" className="mt-[2px]" />
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className={
                            media == "md" || media == "sm" || media == "xs"
                              ? "ml-2"
                              : "ml-5"
                          }
                        >
                          <h1 className="text-[13px] mb-1">
                            For any assistance call us on
                          </h1>
                          <p className="text-[13px] font-semibold mb-1">
                            1800-209-3344
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="bg-[#ebebeb] pl-4 pr-4 pt-3 pb-2 rounded-md mb-3"
                    >
                      <div className="w-[100%] flex">
                        <Image
                          preview={false}
                          src={Question}
                          width={30}
                          height={25}
                        />
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="ml-2"
                        >
                          <h1 className="text-[13px] mb-1">
                            Want us to call you
                          </h1>
                          <p className="cursor-pointer text-[13px] text-[#eb3e43] font-semibold mb-1">
                            Click here
                          </p>
                        </div>
                      </div>
                    </Col>
                    {/* <Col
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className="bg-[#ebebeb] pl-4 pr-4 pt-3 pb-2 rounded-md mb-3"
                >
                  <div className="w-[100%]">
                    <div
                      style={{
                        fontFamily: "Poppins",
                      }}
                    >
                      <h1 className="text-[13px] mb-1">
                        For Franchise Enquiry
                      </h1>
                      <p className="cursor-pointer text-[13px] text-[#eb3e43] font-semibold mb-1">
                        Click here
                      </p>
                    </div>
                  </div>
                </Col> */}
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="bg-[#ebebeb] pl-4 pr-4 pt-3 pb-2 rounded-md mb-3"
                    >
                      <div className="w-[100%] flex">
                        <Image
                          preview={false}
                          src={Comment}
                          width={30}
                          height={25}
                        />
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="ml-2"
                        >
                          <h1 className="text-[13px] mb-1">
                            We value your comments and suggestions
                          </h1>
                          <p className="cursor-pointer text-[13px] text-[#eb3e43] font-semibold mb-1">
                            Click here
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="bg-[#ebebeb] pl-4 pr-4 pt-3 pb-2 rounded-md mb-3"
                    >
                      <div className="w-[100%] flex">
                        <Image
                          preview={false}
                          src={Comment}
                          width={45}
                          height={25}
                        />
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="ml-2"
                        >
                          <h1 className="text-[13px] mb-1">
                            In case you are not satisfied with the level of
                            support & assistance.
                          </h1>
                          <p className="cursor-pointer text-[13px] text-[#eb3e43] font-semibold mb-1">
                            Click here
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className={
                    media == "md" || media == "sm" || media == "xs"
                      ? "pl-0"
                      : "pl-4"
                  }
                >
                  <Row>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="bg-[#ebebeb] pl-4 pr-4 pt-3 pb-2 rounded-md mb-3"
                    >
                      <div className="w-[100%] flex">
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="ml-1"
                        >
                          <div className="flex">
                            <BankFilled className="text-[25px] mt-[-5px] mr-2" />
                            <div>
                              <h1 className="text-[14px] mt-[4px] flex font-semibold">
                                Plan Mi Trip Limited
                              </h1>
                              <p className="text-[13px] mb-2">(Head Office)</p>
                            </div>
                          </div>
                          <p className="text-[13px] mb-3">
                            <span className="font-semibold">Shop No 11</span>,
                            Aarvee hotel building First floor, VKK Menon Rd, New
                            Siddhapudur, Coimbatore, Tamil Nadu - 641044
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="pt-3 pb-2 rounded-md mb-3"
                    >
                      <div className="w-[100%] flex">
                        <div className="w-full h-64 rounded-md overflow-hidden shadow">
                          <iframe
                            title="Area Map"
                            src={mapSrc}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                          ></iframe>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[14px] font-semibold mb-1"
                  >
                    Connect With Us
                  </h1>
                </Col>
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className="mt-2"
                >
                  <Row>
                    <div
                      style={{
                        borderRadius: "200px",
                        border: "1px solid #f9646882",
                      }}
                      onClick={() => {
                        window.open(
                          "https://www.facebook.com/planmitrip.india/"
                        );
                      }}
                      className="pl-[10px] pr-[10px] pt-2 pb-2 mr-5 cursor-pointer"
                    >
                      <FaFacebook className="text-[18px]" />
                    </div>
                    {/* <div
                      style={{
                        borderRadius: "200px",
                        border: "1px solid #f9646882",
                      }}
                      className="pl-[10px] pr-[10px] pt-2 pb-2 mr-5 cursor-pointer"
                    >
                      <GoogleCircleFilled className="text-[18px]" />
                    </div> */}
                    <div
                      style={{
                        borderRadius: "200px",
                        border: "1px solid #f9646882",
                      }}
                      onClick={() => {
                        window.open(
                          "https://www.youtube.com/channel/UCKXctel46iL_KLYwsltC1Sg"
                        );
                      }}
                      className="pl-[10px] pr-[10px] pt-2 pb-2 mr-5 cursor-pointer"
                    >
                      <IoLogoYoutube className="text-[18px]" />
                    </div>
                    {/* <div
                      style={{
                        borderRadius: "200px",
                        border: "1px solid #f9646882",
                      }}
                      className="pl-[10px] pr-[10px] pt-2 pb-2 mr-5 cursor-pointer"
                    >
                      <PinterestOutlined className="text-[18px]" />
                    </div> */}
                    <div
                      style={{
                        borderRadius: "200px",
                        border: "1px solid #f9646882",
                      }}
                      onClick={() => {
                        window.open(
                          "https://www.instagram.com/planmitrip/?hl=en"
                        );
                      }}
                      className="pl-[10px] pr-[10px] pt-2 pb-2 mr-5 cursor-pointer"
                    >
                      <InstagramOutlined className="text-[18px]" />
                    </div>
                    <div
                      style={{
                        borderRadius: "200px",
                        border: "1px solid #f9646882",
                      }}
                      onClick={() => {
                        window.open("https://x.com/planmitrip");
                      }}
                      className="pl-[10px] pr-[10px] pt-2 pb-2 mr-5 cursor-pointer"
                    >
                      <XOutlined className="text-[18px]" />
                    </div>
                    <div
                      style={{
                        borderRadius: "200px",
                        border: "1px solid #f9646882",
                      }}
                      className="pl-[10px] pr-[10px] pt-2 pb-2 mr-5 cursor-pointer"
                    >
                      <FaLinkedin className="text-[18px]" />
                    </div>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col
          md={24}
          sm={24}
          xs={24}
          lg={8}
          xl={8}
          xxl={8}
          className={
            media == "md" || media == "sm" || media == "xs"
              ? "pl-0 mt-[80px]"
              : "pl-6 mt-4"
          }
        >
          {/* <Image src={ContactUsLogo} preview={false} width={400} height={350} /> */}

          <Row className="border border-1 bg-[#ffffff] shadow-md rounded-md p-3">
            <Col
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              xs={24}
              sm={24}
              className="pr-3 mb-1"
            >
              <Typography
                style={{
                  fontFamily: "Poppins",
                }}
                className="input-label mb-2 text-[18px] font-extrabold"
              >
                Send Message
              </Typography>
            </Col>
            <Col
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              xs={24}
              sm={24}
              className="pr-3 mb-1"
              style={{
                fontFamily: "Poppins",
              }}
            >
              <Typography className="mb-2 text-[12px] input-label">
                Full Name
              </Typography>
              <Input
                name="prefixValue"
                className={"rounded-md h-[40px] input-label"}
                placeholder="Enter name"
              />
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-1 mt-2"
            >
              <Typography className="mb-2 text-[12px] input-label">
                Email
              </Typography>
              <Input
                name="mail"
                className={"rounded-md h-[40px] input-label"}
                placeholder="Enter mail"
              />
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-1 mt-2"
            >
              <Typography className="mb-2 text-[12px] input-label">
                Mobile
              </Typography>
              <Input
                name="mail"
                className={"rounded-md h-[40px] input-label"}
                placeholder="Enter mobile no"
              />
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-1 mt-2"
            >
              <Typography className="mb-2 text-[12px] input-label">
                Message
              </Typography>
              <Input.TextArea
                name="prefixValue"
                className={"rounded-md input-label h-[60px]"}
                placeholder="Enter message"
              />
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-5"
            >
              <div
                className={
                  media == "sm" || media == "xs"
                    ? "w-[100%] hover bg-[#eb3e43] text-center hover:bg-[red] h-[30px] text-[14px] mt-1"
                    : "w-[100%] hover bg-[#eb3e43] text-center hover:bg-[red] h-[40px] text-[16px] mt-1"
                }
                style={{
                  borderRadius: "4px",
                  fontFamily: "Poppins",
                  fontWweight: 800,
                  color: "white",
                  cursor: "pointer",
                  marginTop: "3px",
                  padding: "8px 10px",
                  zIndex: 20,
                }}
              >
                Send Message
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

ContactUs.propTypes = {
  location: PropTypes.any,
};

export default withRouter(ContactUs);
